(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initSticky() {
    var info = document.querySelector('product-info');
    if (!info || info.querySelector('.muneera-sticky')) return;
    var first = info.querySelector('.product-form__submit');
    if (!first) return;

    var bar = document.createElement('div');
    bar.className = 'muneera-sticky';
    var box = document.createElement('div');
    box.className = 'muneera-sticky__info';
    var title = document.createElement('span');
    title.className = 'muneera-sticky__title';
    var price = document.createElement('span');
    price.className = 'muneera-sticky__price';
    box.appendChild(title);
    box.appendChild(price);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'muneera-sticky__btn';
    bar.appendChild(box);
    bar.appendChild(btn);
    info.appendChild(bar);

    var h1 = info.querySelector('.product__title h1');
    title.textContent = h1 ? h1.textContent.trim() : '';

    function current() {
      return info.querySelector('.product-form__submit');
    }

    function sync() {
      var s = current();
      if (!s) return;
      var label = s.querySelector('span');
      btn.textContent = label ? label.textContent.trim() : 'Ajouter au panier';
      btn.disabled = s.disabled || s.getAttribute('aria-disabled') === 'true';
      var p = info.querySelector('.price-item--last');
      price.textContent = p ? p.textContent.trim() : '';
    }

    btn.addEventListener('click', function () {
      var s = current();
      if (s && !s.disabled) s.click();
    });

    sync();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (!bar.contains(muts[i].target)) { sync(); return; }
      }
    }).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(first);
    } else {
      bar.classList.add('is-visible');
    }
  }

  function showMessage(el, text) {
    if (!el) return;
    el.textContent = text;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 3000);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.muneera-look__add[data-variant-id]') : null;
    if (!b) return;
    var sec = b.closest('.muneera-look');
    var msg = sec ? sec.querySelector('.muneera-look__msg') : null;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    b.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(b.getAttribute('data-variant-id')), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (d) { showMessage(msg, (d.product_title || d.title) + ' ajouté au panier'); })
      .catch(function () { showMessage(msg, 'Erreur lors de l\u2019ajout au panier.'); })
      .then(function () { b.disabled = false; });
  });

  ready(initSticky);
})();
